import { UrlApi } from "../../../../../../services/apirest";

export { crearRenglonPedido } from "../../../NuevoPedido/componetizado/services/pedidosService";

// El backend responde 500 si falla el UPDATE; se lanza error para que el
// guardado pueda cortar y reintentar.
const putJson = async (ruta, payload) => {
  const res = await fetch(UrlApi + ruta, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    throw new Error(`Error HTTP ${res.status} en ${ruta}`);
  }
  return res.json();
};

// Renglones activos del pedido (incluye id_uso del producto).
export const getRenglonesPedido = async (uuidPedido) => {
  const res = await fetch(UrlApi + "/envasado_pedidos_renglon/renglones/" + uuidPedido);
  if (!res.ok) {
    throw new Error(`Error HTTP ${res.status} al obtener los renglones`);
  }
  const data = await res.json();
  if (!Array.isArray(data)) {
    throw new Error("Respuesta inválida al obtener los renglones");
  }
  return data;
};

export const getDireccionesCliente = async (idCliente) => {
  const res = await fetch(UrlApi + "/envasado_direcciones_entrega/cli/" + idCliente);
  if (!res.ok) {
    throw new Error(`Error HTTP ${res.status} al obtener las direcciones`);
  }
  return res.json();
};

export const actualizarPedido = (idPedido, payload) =>
  putJson("/envasado_pedidos/" + idPedido, payload);

export const actualizarRenglon = (idRenglon, payload) =>
  putJson("/envasado_pedidos_renglon/" + idRenglon, payload);

// Igual que el original: el renglón no se borra, se marca activo = 0.
export const darDeBajaRenglon = (idRenglon, usuario) =>
  putJson("/envasado_pedidos_renglon/" + idRenglon, { activo: 0, usuario });
